import { CURSOR_TYPE, DYMODE_MODE, Listeners, MoveControl, PrimitiveColor, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { PYTHA_CTRL_TYPE } from "../enums/control-type";
import { MonixMoveCommand } from "../commands/MonixMoveCommand";


const STEP = {
    0: { 'tip': '选择对象', 'mode': DYMODE_MODE.TIPONLY },
    1: { 'tip': '指定基点', 'mode': DYMODE_MODE.POINT },
    2: { 'tip': '指定第二个点（距离）', 'mode': DYMODE_MODE.DIST },
}

export class MonixMoveControl extends MoveControl {

    id = PYTHA_CTRL_TYPE.PYTHA_MOVE;
    constructor(editor: ViewEditor, listeners: Listeners, isSubClass: boolean = false) {
        super(editor, listeners, true);
        if (isSubClass) return;
        // 使用构造函数，在创建类的对象时，直接给成员变量赋值
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = this.extraContext.getCurrentViewEditor();
        this.listeners = listeners;
        this.line._isHelpLine = true;
        this.line.color.set(PrimitiveColor.editColor)
        // 注册监听指针事件
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        // 订阅动态输入改变信号，收听到动态输入信息
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        // 订阅确认信号
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // 订阅点捕捉信号，收听到捕捉点的坐标
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        // 订阅正交信号，收听到正交模式点的坐标
        this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        // 订阅极轴追踪信号，收听到极轴追踪点的坐标
        this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        // 激活选择
        this.editor.selectControl.setEnabled(true);
        // 激活动态输入
        this.extraContext.dymodeContext.enabled = true;
        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;

        this.selectedEntities = this.editor.selectControl.getSelectedEntityList().filter(entity => !entity.lock);
        if (this.selectedEntities.length === 0) {
            // 派发动态输入信息
            this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
            this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
            this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
            this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        } else {
            this.step++;
            // 钝化选择
            this.editor.selectControl.setEnabled(false);
            // 派发需要捕捉的信号
            this.listeners.signals.needCapture.dispatch();
            this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
            this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
            this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
            this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        }
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.point_first.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.point_second.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        console.log('MonixMoveControl added')
    }

    dispose(): void {

        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.noNeedCapture.dispatch();
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.editor.orthogonalControl.enabled = false;
        this.editor.polarControl.enabled = false;
        let obj = this.line.viewObj;
        if (obj && !!obj.parent) {
            obj.parent.remove(obj);
        }
        // for (let i = 0; i < this.selectedEntitiesClone.length; i++) {
        //     let entityClone = this.selectedEntitiesClone[i];
        //     this.extraContext.sceneContext.scene.remove(entityClone.viewObj);
        // }
        // this.relatedLinesClone.forEach(dto => {
        //     if (dto.model.viewObj) {
        //         this.extraContext.sceneContext.scene.remove(dto.model.viewObj);
        //     }
        // })

        // 新的销毁方式
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object != null) {
                mapItem.object.parent?.remove(mapItem.object);
            }
        }
        delete this._copyEntitiyMap;

        this.editor.listeners.signals.needRender.dispatch();
        console.log('MonixMoveControl removed')
    }


    lastStep = () => {
        let first = this.point_first;
        let second = this.point_second;
        let dir = second.clone().sub(first.clone()).normalize();
        let dist = first.distanceTo(second);
        let entities = this.selectedEntities;
        this.editor.history.execute(new MonixMoveCommand(entities, dir, dist, []));

        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    protected _dymodeActive = false;

}